import styled from "styled-components";

export const MyInstumentTuneBookingStyled = styled.div`
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
  .booking_status_wrap {
    margin-bottom: 12px;
    display: flex;
    .booking_status {
      padding: 5px 20px;
      border-radius: 50px;
      background: ${({ theme }) => theme.COLORS.GREEN_2};
      text-align: center;
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .booking_date {
    margin-bottom: 26px;
    display: flex;
    column-gap: 20px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .booking_desc {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    &.mb15 {
      margin-bottom: 15px;
    }
  }
  .booking_footer {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }

  .theme_standard {
  }
`;
